import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@mm-aggregator/drf-dynamics';

/** Hub aggregate payload from transaction / mandate / batch viewsets. */
export type TransactionHubPayload = Record<string, unknown>;

@Injectable({ providedIn: 'root' })
export class TransactionHubService {
  private readonly api = inject(ApiService);

  getHub(listPath: string, id: string): Observable<TransactionHubPayload> {
    const base = listPath.replace(/\/$/, '');
    return this.api.get<TransactionHubPayload>(`${base}/${id}/hub/`);
  }

  postRefundFromHub(
    listPath: string,
    id: string,
    body: { reason: string; password: string; reason_code?: string; amount?: string },
  ): Observable<unknown> {
    const base = listPath.replace(/\/$/, '');
    return this.api.post(`${base}/${id}/refund-from-hub/`, body);
  }

  postStatusCheckFromHub(
    listPath: string,
    id: string,
    body: { reference: string },
  ): Observable<unknown> {
    const base = listPath.replace(/\/$/, '');
    return this.api.post(`${base}/${id}/status-check/`, body);
  }

  getBatchUploadKey(): Observable<{ public_key: string; algorithm: string }> {
    return this.api.get<{ public_key: string; algorithm: string }>(
      'records/batch-disbursements/upload-key/',
    );
  }

  submitSealedBatch(body: Record<string, unknown>): Observable<unknown> {
    return this.api.post('records/batch-disbursements/submit-sealed/', body);
  }
}
